/* eslint react-hooks/exhaustive-deps: "warn" */
import { useInt } from 'hooks/useInt';

import { CaseStudyCard } from 'landing-pages/shared/CaseStudyCard/CaseStudyCard';

export const GovernmentTestimonial = () => {
  const { t } = useInt();

  return (
    <CaseStudyCard
      company="British High Commission"
      title={t('Global Database Helps the British High Commission Improve Trade Opportunities')}
      summary={t(
        'The British High Commission uses verified company data to identify and support genuine trade opportunities between markets — the kind of institutional-grade verification government bodies require.',
      )}
      href="/global-database-helps-british-high-commission-improve-trade-opportunities"
    />
  );
};
